export default {
  // host for API server
  apiHost: 'https://api.dsh-agency.com',
  apiHostTickets: 'https://tickettool.dsh-agency.com',
  apiHostSandboxOld: 'https://writersandbox.dsh-agency.com',
  // apiHostSandboxNew: 'https://writersandbox-stage.dsh-agency.com',
  apiHostSandboxNew: 'https://writersandbox.dsh-agency.com',
  apiHostAuth: 'https://oauth.dsh-agency.com',
  apiHostAuthBack: 'https://auth-back.dsh-agency.com',
  apiVersionSmsTool: '/api',
  baseUrlWFH: 'https://connect.dsh-agency.com',
  apiHostSmsTool: 'https://connect.dsh-agency.com',
  wstknOld: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MjExMjI4NDUsInN1YiI6MX0.unKDnK0Ro1LDzIP37VvOnHRxDsU2QqUNiEtNBBHtjAY',
  wstknNew: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1MjYzOTQwMjUsInN1YiI6MzYxfQ.Se7aPeF3PWbzMg7EDhxKDGwGNpLnVNQtv73ywR-60Yo',

  writerToolSite: 'https://myaccount.lrwriters.com',
  graderToolSite: 'https://gradertool.lrwriters.com',
  sandboxSite: 'https://recruiting.livingston-research.com',
  lrtutorsSite: 'https://account.lrtutors.com',

  apiHostSocket: 'wss://mqtt.dsh-agency.com:8084/mqtt',

  mynerdifyLink: 'http://mynerdify.com',

  geeklyLabSite: 'https://geeklylab.com',
  geeklyHubSite: 'https://geeklyhub.com',
  homeworkLabSite: 'https://homework-lab.com',
  clientChatMessages: 'https://xmpp.nt.dsh-agency.com/nodes/get_items',
  clientChatFiles: 'https://xmpp.nt.dsh-agency.com/nodes/get_files',
  removeClientChatFiles: 'https://xmpp.nt.dsh-agency.com/nodes/remove_files',
  restoreClientChatFiles: 'https://xmpp.nt.dsh-agency.com/nodes/restore_files',
  apiWriterTriggers: 'https://ps.dsh-agency.com',


  // version of used API
  apiVersionPartV1: '/api/v1',
  apiVersionPart: '/api/v3',
  apiVersionPartV4: '/api/v4',

  a4Host: 'https://a4.dsh-agency.com',

  OCRProxy: 'https://api.dsh-agency.com/h2c',
  OCRResults: 'https://api.dsh-agency.com/ocrspace/parse/image',

  fileServerUrl: 'https://nwzc6p9uv6.execute-api.eu-west-1.amazonaws.com/production_v1',
  lrTrackUrl: 'https://statistic.dsh-agency.com/',
  lrTrackId: 'TICKET_TOOL',

  isSmsTool: false,
};
